import { render, staticRenderFns } from "./my_data.vue?vue&type=template&id=9ca1c782&scoped=true"
import script from "./my_data.vue?vue&type=script&lang=js"
export * from "./my_data.vue?vue&type=script&lang=js"
import style0 from "./my_data.vue?vue&type=style&index=0&id=9ca1c782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca1c782",
  null
  
)

export default component.exports